import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'
import { BLACKGREY, Button, DARKGREY, device, shadow600 } from '../../styles/styles'

const Container = styled.article`
width:100%;
border-radius:10px;
overflow: hidden;
transition: 0.3s ease-in-out;
cursor:pointer;
box-shadow: ${shadow600};
min-height: 500px;
display: flex;
flex-direction: column;

>img{
    width: 100%;
    height: 12.5rem;

    object-fit: cover;
}

@media ${device.laptopSmall}{
    max-width: 350px;
    :hover{
    box-shadow: ${shadow600};

}

}`

const TextContainer = styled.div`
text-align: left;
padding:20px;
display: flex;
flex-direction: column;
flex-grow:1;
row-gap:0.5rem;
>h3{
    font-weight:600;
    color: ${BLACKGREY};
}
>span{
    font-size: 0.9rem;
    color: ${DARKGREY};
    text-transform: uppercase;
    margin-bottom:-0.5rem;
}
>p{
    color: ${DARKGREY}90;
    display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}
>a{
    margin-top:auto;
    align-self: flex-end;
 


}`
const BlogInstance = ({id, image, topic, title, description, url}) => {
  return (
      <Container>
            <img src={image}></img>
            <TextContainer>
                <span className='topic'>{topic}</span>
                <h3 className='title h5'>{title}</h3>
                <p className='description p'>{description}</p>
            <Link href={`/blog/${url}`}>
                <Button className='small'>Read More →</Button>
            </Link>
            </TextContainer>
            
        </Container>
  )
}

export default BlogInstance